import { flatRatePlanNames } from "@common/flatRateBilling";
import classNames from "classnames";
import { OrganizationAssignablePlan } from "@common/constants/organization-billing";
import { FC } from "react";
import { useInteraction } from "@hooks/useInteraction";
import styles from "../BillingPage.module.scss";

interface Props {
    plan: OrganizationAssignablePlan;
    clientsCount: number;
    onPlanSelected(plan: OrganizationAssignablePlan): void;
}
export const ClientsSectionRow: FC<Props> = ({
    plan,
    clientsCount,
    onPlanSelected,
}) => {
    const rowClickInteraction = useInteraction(() => onPlanSelected(plan));

    return (
        <div
            className={classNames(styles.row, {
                [styles.withDetails]: clientsCount > 0,
            })}
            {...rowClickInteraction}
        >
            <div className={classNames(styles.column, styles.item)}>
                {flatRatePlanNames[plan]}
            </div>
            <div className={classNames(styles.column, styles.value)}>
                {clientsCount}
            </div>
        </div>
    );
};
